<template>
    <div>
        <AppPushNotification ref="notification" :title="notificationModel.title" :text="notificationModel.text"
            :color="notificationModel.color" />
        <div v-show="!pageLoading">
            <div class="row mt-5" style="padding-bottom: 50cap;">
                <!-- Bill Details Section -->
                <div class="col-md-6 col-sm-12 p-3">
                    <h4><i class="fi fi-rr-receipt"></i>{{ $t('billDetail') }}</h4>
                    <div class="order-detail-box">
                        <div class="row">
                            <div v-for="(item, index) in billDetails" :key="index"
                                class="col-12 d-flex justify-content-between">
                                <template>
                                    <span>{{ $t(item.label) }}</span>
                                    <span class="text-right">{{ item.value }}</span>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-if="receipt.receiptStatus == 'P'"
                        class="order-detail-box text-grey d-flex justify-content-between align-items-center w-100 mt-2">
                        <span> <i class="fi fi-rr-times-hexagon mr-2 h5" /> {{ $t('cancelPayment') }} </span>
                        <CButton :disabled="btnCancelLoading" @click="cancelPayStatus()" color="danger">
                            <CSpinner size="sm" v-if="btnCancelLoading"></CSpinner>
                            {{ $t('cancel') }}
                        </CButton>
                    </div>
                </div>
                <!-- Payment Method Section -->
                <div class="col-md-6 col-sm-12 p-3">
                    <h4>{{ $t('selectPaymentMethod') }}</h4>
                    <div class="order-detail-box text-grey">
                        <i class="fi fi-rr-bank mr-2" />
                        {{ $t('silomPayProDesp') }}
                    </div>
                    <div class="payment-method-box">
                        <div v-for="(method, index) in filteredPaymentMethods" :key="index" class="payment-option">
                            <label class="payment-label" :for="method.id">
                                <div class="payment-info">
                                    <img class="payment-icon" :src="`/img/paymentIcon/${method.icon}`">
                                    {{ $t(method.name) }}
                                </div>
                                <div class="radio-container">
                                    <input type="radio" :id="method.id" v-model="selectedPayment" :value="method.id" />
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" tabindex="-1" id="qr-payment-modal">
                <div class="modal-dialog">
                    <div class="modal-content" style="background-color: unset;">
                        <div class="small-modal p-0" style="background-color: white;overflow: hidden;">
                            <div class="payment-qr-header"
                                :style="{ backgroundColor: selectedPaymentMethod.bgColor || '#ffffff' }">
                                <img height="40px"
                                    :src="`/img/paymentIcon/${selectedPaymentMethod.iconHeader || selectedPaymentMethod.icon}`"
                                    alt="Payment Header">
                            </div>
                            <div class="payment-qr-body">
                                <div v-if="!loadingQRData" class="text-center w-100">
                                    <h4 class="">{{ table.name }}</h4>
                                    <template v-if="selectedPayment !== 'cash'">
                                        <div class="d-flex align-item-center justify-content-center ">
                                            <vue-qrcode v-if="countdownInterval !== null" class="img-fluid"
                                                :value="qrString" style="width: 60%" />
                                            <i v-else style="font-size: 100px;"
                                                class="fi fi-rr-time-forward row m-2"></i>
                                        </div>
                                        <h4 class="mt-2">{{ paymentReceipt.grandTotal.toFixed(2) }} ฿
                                            <i @click="checkPaymentStatus(true)" v-if="!btnLoading"
                                                style="cursor: pointer;" class="fi fi-rr-refresh h5"></i>
                                            <CSpinner v-else color="dark" />
                                        </h4>
                                        <CAlert color="danger" v-if="isAlertStatus">
                                            {{ $t('haveNotPurchased') }}
                                        </CAlert>
                                        <span v-if="countdownInterval !== null" class="text-dark">{{ $t('expireIn') }}:
                                            {{
                                                formattedCountdown }} {{ $t('minute') }}</span>
                                        <span v-else class="text-danger">{{ $t('paymentTImeExpired') }}</span><br>
                                        <CButton @click="openExternalLink()" v-if="isQRStringURL"
                                            class="mt-3 text-white" color="dark">
                                            <div class="row pl-3 pr-3">
                                                {{ $t('openApp') }}<i
                                                    class="fi fi-rr-arrow-up-right-from-square ml-2"></i>
                                            </div>
                                        </CButton>
                                        <h4 class="mt-3">{{ shop.shopName || '' }}</h4>
                                        <span class="text-grey">{{ $t('account') }} : {{ merchantName }}</span><br>
                                        <span class="text-grey">{{ $t('refNumber') }} : {{ outTradeNo }}</span>
                                    </template>
                                    <template v-else>
                                        <div class="d-flex align-item-center justify-content-center ">
                                            <img width="60%" src="/img/thanks.png">
                                        </div>
                                        <h4 class="mt-4">{{ totalAmount }}฿</h4>
                                        <span class="text-grey" v-html="$t('callPayStaffSuccess')" /><br>
                                    </template>
                                </div>
                                <div v-else class="w-100">
                                    <!-- Skeleton Loading -->
                                    <div class="text-center p-2">
                                        <div class="skeleton-box mb-3"
                                            style="width: 200px; height: 200px; margin: 0 auto;">
                                        </div>
                                        <div v-for="i in 2">
                                            <div class="skeleton-line w-50 mb-2 mt-4"
                                                style="height: 10px; margin: 0 auto;">
                                            </div>
                                            <div class="skeleton-line w-25 mb-2" style="height: 10px; margin: 0 auto;">
                                            </div>
                                            <div class="skeleton-line w-75 mb-2" style="height: 10px; margin: 0 auto;">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="payment-qr-footer">
                                <CButton ref="qrFooter" style="width: 100%;" data-dismiss="modal">{{
                                    $t('closeTab') }}</CButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Fixed Bottom Payment Button -->
            <div class="fixed-bottom">
                <div class="payment-footer">
                    <CButton @click="generateQRPayment()" data-toggle="modal" data-target="#qr-payment-modal"
                        class="btn-color-theme" block>
                        {{ $t('checkOut') }} {{ totalAmount }}฿
                    </CButton>
                </div>
            </div>
        </div>
        <div v-show="pageLoading">
            <div class="lds-ripple">
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
import { CButton, CSpinner } from '@coreui/vue';
import { mapGetters } from 'vuex'
import moment, { ISO_8601 } from 'moment'
import VueQrcode from 'vue-qrcode'
import AppPushNotification from '@/components/AppPushNotification'
import payment from '@/services/payment'
import poscrm from '@/services/poscrm'
import paymentUtil from '@/util/payment';
import util from '@/util/util';
import '@/util/menu.css';

export default {
    components: {
        VueQrcode,
        AppPushNotification
    },
    data() {
        return {
            billDetails: [
                { label: "totalAmount", value: "" },
                { label: "vat", value: "" },
                { label: "serviceCharge", value: "" },
                { label: "orderItem", value: "" },
                { label: "table", value: "" },
                { label: "numberOfGuest", value: "" },
                { label: "orderTime", value: "" }
            ],
            selectedPayment: "cash", // Default selected payment method
            btnLoading: false,
            countdown: 600, // 10 minutes in seconds
            countdownInterval: null,
            loadingQRData: true,
            qrString: '',
            outTradeNo: '',
            merchantName: '',
            messageStatus: '',
            paymentReceipt: {},
            isAlertStatus: false,
            checkPaymentInterval: null,
            isCheckingPayment: false,
            orderShopSetting: null,
            pageLoading: false,
            isQRSelfCheckOut: false,
            receipt: {},
            btnCancelLoading: false,
            notificationModel: {
                color: '',
                title: '',
                text: '',
            },
        };
    },
    mounted() {
        $('#qr-payment-modal').on('shown.bs.modal', () => {
            this.loadingQRData = true;
            this.startCountdown();
            // Start polling payment status every 3 seconds if QR is ready
            this.checkPaymentInterval = setInterval(() => {
                if (!this.loadingQRData && this.selectedPayment !== 'cash') {
                    this.checkPaymentStatus(false);
                }
            }, 3000);
        });
        $('#qr-payment-modal').on('hidden.bs.modal', () => {
            this.loadingQRData = true;
            this.stopCountdown();
            // Stop checking when modal is closed
            clearInterval(this.checkPaymentInterval);
            this.checkPaymentInterval = null;
            this.removeModalArtifacts();
        });
    },

    computed: {
        ...mapGetters(['shopLineOA']),
        totalAmount() {
            return this.billDetails.find(item => item.label === "totalAmount")?.value || "0.00";
        },
        selectedPaymentMethod() {
            return this.paymentMethods.find(method => method.id === this.selectedPayment) || {};
        },
        formattedCountdown() {
            const minutes = Math.floor(this.countdown / 60).toString().padStart(2, '0');
            const seconds = (this.countdown % 60).toString().padStart(2, '0');
            return `${minutes}:${seconds}`;
        },
        uid() {
            return localStorage.getItem('uid')
        },
        shopObjectId() {
            return localStorage.getItem('shopObjectId')
        },
        shop() {
            return this.shopLineOA.find(
                (detail) => detail.objectId === this.shopObjectId
            )
        },
        table() {
            return JSON.parse(localStorage.getItem('table'))
        },
        isQRStringURL() {
            let qrString = this.qrString || ''
            try {
                const pattern = /^(https?:\/\/|[a-zA-Z]+:\/\/)/;
                return pattern.test(qrString);
            } catch (err) {
                return false;
            }
        },
        filteredPaymentMethods() {
            // Show only cash if not pay-before-eat
            if (!this.isQRSelfCheckOut) {
                return this.paymentMethods.filter(method => method.id === 'cash');
            }
            // Fallback if shop or GHLMethodEnabled is not defined
            if (!this.shop || !this.shop.GHLMethodEnabled || !this.shop.GHLMethodEnabled.enabled) {
                return this.paymentMethods.filter(method => method.id === 'cash');
            }

            const enabledTypes = this.shop.GHLMethodEnabled.methods;

            // Always include cash, plus those with enabled types
            return this.paymentMethods.filter(method =>
                method.id === 'cash' || enabledTypes.includes(method.type)
            );
        },
        paymentMethods() {
            return util.getGHLPaymentMethods()
        }

    },
    async created() {
        this.getReceiptTransaction()
        this.getOrderShopSetting()
    },
    methods: {
        async checkPaymentStatus(isAlert) {
            if (this.isCheckingPayment) {
                this.btnLoading = isAlert;
                this.isAlertStatus = isAlert;
                if (isAlert) {
                    setTimeout(() => {
                        this.isAlertStatus = false;
                    }, 10000);
                }
                return; // 🚫 ถ้าเคยกำลังโหลดอยู่แล้ว ไม่ให้เรียกซ้ำ
            }
            this.isCheckingPayment = true;

            try {
                const receiptObjectId = localStorage.getItem('receiptObjectId');
                const res = await payment({
                    url: `/gateway/payment/v1.0/${this.uid}/orders/${receiptObjectId}/check`,
                    method: 'GET',
                    headers: {
                        GATEWAY: 'GHL',
                        posObjectId: '001',
                        shopObjectId: this.shopObjectId
                    },
                });

                const successState = ['TRADE_SUCCESS', 'SALE', 'SUCCESS'];
                if (!successState.includes(res.data?.data?.trade_state)) {
                    this.isAlertStatus = isAlert;
                    if (isAlert) {
                        setTimeout(() => {
                            this.isAlertStatus = false;
                        }, 10000);
                    }
                } else {
                    await this.createRequest('ชำระเงินสำเร็จ')
                    $('#qr-payment-modal').modal('hide');
                    this.removeModalArtifacts();
                    this.stopCountdown();
                    clearInterval(this.checkPaymentInterval);
                    this.checkPaymentInterval = null;
                    const BaseURL = process.env.VUE_APP_WEB_URL
                    const token = await this.generateToken();
                    const trackingURL = `${BaseURL}/receipt/view/${receiptObjectId}?token=${token}`
                    if (this.orderShopSetting?.isQRSelfCheckOut == true) {
                        // await this.stampReceiptCompleted()
                        window.open(trackingURL, '_blank');
                        this.$router.push(`/dine-in/menulists?tracking=${trackingURL}`);
                    } else {
                        // await this.stampReceiptCompleted()
                        this.$router.push(`/dine-in/menulists`);
                    }
                }
            } catch (err) {
                console.error('Error checking payment:', err);
            } finally {
                this.btnLoading = false;
                this.isCheckingPayment = false; // ✅ ปลดล็อกหลังโหลดเสร็จ
            }
        },
        startCountdown() {
            this.countdown = 600;
            if (this.countdownInterval) clearInterval(this.countdownInterval);
            this.countdownInterval = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                    // Stop payment polling when time runs out
                    clearInterval(this.checkPaymentInterval);
                    this.checkPaymentInterval = null;
                }
            }, 10000);
        },
        stopCountdown() {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        },
        async generateQRPayment() {
            this.loadingQRData = true
            const type = this.selectedPaymentMethod.type || null
            if (type == 'cash') {
                await this.createRequest('ชำระเงิน')
                return
            }
            const receipt = await this.generatePaymentReceipt() || null
            if (type == null || receipt == null) {
                this.$router.push('/dine-in/menulists')
                return
            }
            const res = await payment({
                url: `/gateway/payment/v1.0/${this.uid}/createqr?type=qr`,
                method: 'post',
                headers: { gateway: 'GHL' },
                data: paymentUtil.PaymentGHLDefault(type, receipt)
            });

            if (res.data?.error?.code == 0) {
                this.qrString = res.data?.data?.code_url || ''
                this.outTradeNo = res.data?.data?.out_trade_no || ''
                this.merchantName = res.data?.data?.name || this.shop?.shopName || ''
                this.loadingQRData = false
            }
        },
        async generatePaymentReceipt() {
            const res = await poscrm({
                url: `/api/v1.1/${this.uid}/Receipt/selforder/generatepayment`,
                method: 'post',
                data: {
                    receiptObjectId: localStorage.getItem('receiptObjectId'),
                    paymentType: 13
                }
            });
            if (res?.data?.error?.code == 0) {
                this.paymentReceipt = res?.data?.data
                return res?.data?.data || null
            } else {
                return null
            }
        },
        async createRequest(message) {
            let table = JSON.parse(localStorage.getItem('table')) || []
            let receiptObjectId = localStorage.getItem('receiptObjectId') || ''

            let data = {
                "id": "",
                "uid": this.uid,
                "receiptObjectId": receiptObjectId,
                "shop": {
                    "id": this.shop.id,
                    "objectId": this.shopObjectId,
                    "shopName": this.shop.shopName,
                    "branchName": this.shop.branchName
                },
                "scope": "table",
                "scopeData": {
                    "id": table.id || table.objectId,
                    "objectId": table.objectId
                },
                "title": "New Message",
                "message": message,
                "created_at": moment().toISOString(),
                "status": "new",
                "action": "alert",
                "priority": "low",
                "read_at": null,
                "expired": null,
                "group": "none",
                "ref": "none",
                "tableLayout": localStorage.getItem('tableLayout') || false,
                "isTracking": true
            }
            try {
                await poscrm({
                    url: process.env.VUE_APP_MESSAGE_CALLSTAFF,
                    data: data,
                    method: 'post',
                }).then((res) => {
                    switch (res.data?.error?.code) {
                        case 0:
                            this.loadingQRData = false
                            break;
                        case 4001:
                            this.$router.push('/dine-in/selecteditem');
                            break;
                        case 3801:
                            this.showNotification(this.$t('tableHasNoOrder'), this.$t('contactOurStaff2'), 'warning')
                            setTimeout(() => {
                                this.$refs.qrFooter.click()
                            }, 2000);
                            break;
                        default:
                            break;
                    }
                })
            } catch (error) {
                throw new Error(error)
            }
        },
        async getReceiptTransaction() {
            try {
                const receiptObjectId = localStorage.getItem('receiptObjectId');
                const res = await poscrm.get(`/api/v1.1/${this.uid}/Receipt/data/${receiptObjectId}`);

                const receipt = res.data?.data?.document;
                this.receipt = receipt
                if (!receipt) return;

                if (['A', 'T'].includes(receipt.receiptStatus)) {
                    this.$router.push('/dine-in/selecteditem');
                    return;
                }

                const rawDetails = [
                    { label: "totalAmount", value: +receipt.grandTotal || 0 },
                    { label: "serviceCharge", value: +receipt.serviceCharge || 0 },
                    { label: "vat", value: +receipt.vatAmount || 0 },
                    { label: "orderItem", value: `${receipt.receiptItems?.length || 0} ${this.$t('item')}` },
                    { label: "table", value: receipt.tableName || "-" },
                    { label: "numberOfGuest", value: `${receipt.numCust || 1} ${this.$t('guest')}` },
                    { label: "orderTime", value: receipt.created_at ? moment(receipt.created_at).format('DD/MM/YYYY, HH:mm:ss') : "-" }
                ];

                this.billDetails = rawDetails.filter(item => {
                    // Keep all non-number values, and only numbers > 0
                    return typeof item.value !== 'number' || item.value > 0;
                }).map(item => ({
                    ...item,
                    value: typeof item.value === 'number' ? item.value.toFixed(2) : item.value
                }));
            } catch (error) {
                throw new Error(error);
            }
        },
        openExternalLink() {
            if (this.isQRStringURL) {
                window.open(this.qrString, '_blank');
            } else {
                console.warn('QR string is not a valid URL or deeplink:', this.qrString);
            }
        },
        async generateToken() {
            try {
                const receiptObjectId = localStorage.getItem('receiptObjectId');

                const res = await poscrm({
                    method: 'post',
                    url: '/api/v1.0/selforder/generate/receiptview/token',
                    data: {
                        payload: {
                            sub: 'view-receipt',
                            receiptObjectId: receiptObjectId,
                        },
                        expiresIn: '1h' // ⏰ อายุ token
                    }
                });
                const token = res.data?.data?.token;
                return token
            } catch (error) {
                console.error('Error generating token:', error);
            }
        },
        async getOrderShopSetting() {
            this.pageLoading = true
            const uid = `${localStorage.getItem('uid')}`
            const shopObjectId = `${localStorage.getItem('shopObjectId')}`

            let params = {
                shopObjectId: shopObjectId,
            }
            try {
                await poscrm({
                    method: 'get',
                    url: '/api/v2.1/' + uid + '/OrderShopSetting',
                    params: params,
                }).then((res) => {
                    this.orderShopSetting = res.data?.data?.[0] || null
                    this.isQRSelfCheckOut = this.orderShopSetting?.isQRSelfCheckOut || false

                })
            } catch (error) {
                throw new Error(error)
            } finally {
                this.pageLoading = false
            }
        },
        async stampReceiptCompleted() {
            const receiptObjectId = localStorage.getItem('receiptObjectId');
            const res = await poscrm({
                method: 'post',
                url: '/api/v1.0/selforder/stamp/receiptcompleted',
                data: { receiptObjectId }
            });
        },
        removeModalArtifacts() {
            // Remove modal backdrop and any leftover Bootstrap classes
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
        },
        async cancelPayStatus() {
            this.btnCancelLoading = true
            let data = {
                receiptObjectId: this.receipt.objectId
            }
            try {
                await poscrm({
                    url: '/api/v1.1/' + this.uid + '/Receipt/selforder/paymentstatus/cancel',
                    data: data,
                    method: 'post',
                }).then((res) => {
                    this.$router.push('/dine-in/menulists')
                    console.log('Unlocked Payment')
                })
            } catch (error) {
                throw new Error(error)
            } finally {
                this.btnCancelLoading = false
            }
        },
        showNotification(title, text, color) {
            this.notificationModel = {
                color: color,
                title: title,
                text: text,
            }
            this.$refs.notification.pushNotification();
        },

    },
};
</script>